// extracted by mini-css-extract-plugin
export default {"colorTangelo":"#fc4c02","NewProfit":"NewProfit_NewProfit__kTPcC","no-hover":"NewProfit_no-hover__+O2Ss","NewProfit--dark":"NewProfit_NewProfit--dark__FFraP"};